<template lang="pug">
modal(:max-width="3000", style="overflow:hidden;", v-if="item")
	.btnCerrar(@click="cerrar") &times;
	.capaContenido(ref="contenido")
		// div.capaFlechas
		div.flechaIzquierda
			span.fa.fa-caret-left(@click="anterior")
		div.flechaDerecha
			span.fa.fa-caret-right(@click="siguiente")
		div(v-if="item.Tipo === 'Foto'")
			div.item(:style="estilo")
				img(:style="estiloImg", :src="'src/modulos/galerias/php/api/hd.php?ItemID=' + this.item.ItemID")
		div(v-else)
			video(autoplay="true", controls="true", :style="estilo", :src="'src/modulos/galerias/php/api/play.php?ItemID=' + item.ItemID")
	.capaInformacion.p-2.pt-3
		h3 Información
		div.text-left(style="margin-top:30px;font-size:1.2em;")
			h3
				small
					b {{item.titulo || 'Sin título'}}
					br
			h4
				small
					| {{item.GaleriaNombre}}
			p.text-dark.mt-4
				span.fa.fa-user.mr-2
				| Usuario
				br
				span(style="color:#777777;") {{item.UsuarioNombre}}
			p.text-dark
				span.fa.fa-calendar.mr-2
				| Fecha de subida
				br
				span(style="color:#777777;") {{item.FechaSubido}}
			p.text-dark
				span.fa.fa-user.mr-2
				| Tamaño
				br
				span(style="color:#777777;") {{tamano}}
			p.text-dark
				span.fa.fa-image.mr-2
				| Dimensiones
				br
				span(style="color:#777777;") {{item.Ancho}} x {{item.Alto}}
			p.text-center(v-if="galeria.Escritura")
				.btn-group.text-center
					button.btn.btn-warning(@click="setPortada", v-if="galeria.Escritura")
						span.fa.fa-image.mr-2
						| Definir portada
					a.btn.btn-success(target="_blank", :href="'/src/modulos/galerias/php/api/download.php?ItemID=' + itemId")
						span.fa.fa-download
					//- button.btn.btn-primary(@click="toggleFavorito", v-if="galeria.Escritura")
					//- 	span.fa.fa-star
					button.btn.btn-danger(@click="eliminar", v-if="galeria.Escritura")
						span.fa.fa-trash
			div.bg-light(style="margin:-5px;margin-bottom:15px;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0; padding:2px;padding-top:10px;")
				h4
					span.fa.fa-users.mr-2
					| Personas
			.input-group(v-if="galeria.Escritura")
				.input-group-prepend
					.input-group-text
						span.fa.fa-user
				input-query.form-control(input-class="form-control", :realtime="true", url="galerias/php/api/query-personas.php", @selected="setPersona($event)", placeholder="Busca o crea una persona")
			div.mt-3
				p.text-center.text-danger(v-if="item.personas.length === 0") No hay personas
				table.table.table-condensed.table-striped(v-if="item.personas.length > 0")
					tbody
						tr(v-for="persona in item.personas", :key="persona.PersonaID")
							td.text-center(style="width:25px;")
								span.fa.fa-user
							td.text-left {{persona.Nombre}} {{persona.Apellidos}}
							td.text-right(style="width:40px;")
								button.btn.btn-sm.btn-danger(@click="delPersona(persona)")
									span.fa.fa-trash
			div.bg-light(style="margin:-5px;margin-bottom:15px;margin-top:15px;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0; padding:2px;padding-top:10px;")
				h4
					span.fa.fa-tags.mr-2
					| Etiquetas
			.input-group.mt-3.mb-3(v-if="galeria.Escritura")
				.input-group-prepend
					.input-group-text
						span.fa.fa-tag
				input.form-control(placeholder="Añade etiquetas", v-model="etiqueta", @keypress.enter="setEtiqueta")
			div.btn.btn-danger.btn-sm.m-1(v-for="tag in item.etiquetas", :key="tag.Etiqueta", @click="delEtiqueta(tag.Etiqueta)")
				| {{tag.Etiqueta}}
				span.ml-2.fa.fa-trash(v-if="galeria.Escritura")
			div.text-center(v-if="item.etiquetas.length === 0") No hay etiquetas
			div.mt-4(style="color:#777777;")
				| Heredadas de la galería
			div.btn.btn-danger.btn-sm.m-1(v-for="tag in galeria.etiquetas", :key="tag") {{tag}}
</template>
<script>
import API from '../../api'
export default {
	props: ['itemId', 'listado'],
	data () {
		return {
			estilo: null,
			estiloImg: null,
			etiqueta: '',
			persona: '',
			item: null,
			galeria: null
		}
	},
	mounted () {
		this.calcular()
		window.addEventListener('resize', this.calcular)
		window.addEventListener('keyup', this.teclaPulsada)
	},
	created () {
		this.getItem()
	},
	watch: {
		itemId (newVal) {
			this.getItem()
		}
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.calcular)
		window.removeEventListener('keyup', this.teclaPulsada)
	},
	computed: {
		tamano () {
			const bytes = this.item.Tamano
			const decimals = 2
			if (bytes === 0) return '0 Bytes'
			let k = 1024
			let dm = decimals <= 0 ? 0 : decimals || 2
			let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
			let i = Math.floor(Math.log(bytes) / Math.log(k))
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
		}
	},
	methods: {
		getItem () {
			if (this.estilo) {
				this.estilo.display = 'none'
			} else {
				this.estilo = {
					display: 'none'
				}
			}

			API.getItem(this.itemId)
				.then(res => {
					this.item = res.data.item
					this.galeria = res.data.galeria
					this.calcular()
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		teclaPulsada (ev) {
			switch (ev.keyCode) {
			case 27:
				this.cerrar()
				break
			case 39:
				this.siguiente()
				break
			case 37:
				this.anterior()
				break
			case 46:
				this.eliminar()
				break
			default:
			}
		},
		siguiente () {
			let i = this.listado.indexOf(this.itemId)
			if (i === this.listado.length - 1) {
				i = 0
			} else {
				i++
			}
			this.$emit('update:itemId', this.listado[i])
		},
		anterior () {
			let i = this.listado.indexOf(this.itemId)
			if (i === 0) {
				i = this.listado.length - 1
			} else {
				i--
			}
			this.$emit('update:itemId', this.listado[i])
		},
		calcular () {
			if (!this.item) {
				return
			}

			let altoVideo = this.item.Alto
			let anchoVideo = this.item.Ancho
			let rotacion = 0

			// Vemos la información exif de la imagen
			if (this.item.exif) {
				const orientacion = this.item.exif.Orientation
				if (orientacion) {
					switch (orientacion) {
					case 3:
						rotacion = 180
						break
					case 6:
						rotacion = 90
						altoVideo = this.item.Ancho
						anchoVideo = this.item.Alto
						break
					case 8:
						rotacion = 270
						// altoVideo = this.item.Ancho
						// anchoVideo = this.item.Alto
						break
					default:
						rotacion = 0
						break
					}
				}
			}

			console.log('La rotación es: ' + rotacion)

			let rVideo = anchoVideo / altoVideo

			// Dimensiones de la ventana
			const altoVentana = window.innerHeight
			const anchoVentana = window.innerWidth - 300
			// const rVentana = anchoVentana / altoVentana

			if (anchoVentana / rVideo < altoVentana) {
				const alto = anchoVentana / rVideo
				this.estilo = {
					position: 'fixed',
					display: 'block',
					top: Math.round((altoVentana - alto) / 2) + 'px',
					left: 0,
					width: anchoVentana + 'px',
					height: alto + 'px',
					overflow: 'hidden'
				}

				this.estiloImg = JSON.parse(JSON.stringify(this.estilo))
				this.estiloImg.transform = 'rotate(' + rotacion + 'deg)'
				delete this.estiloImg.transform
			} else {
				const ancho = altoVentana * rVideo
				this.estilo = {
					position: 'fixed',
					display: 'block',
					top: 0,
					left: Math.round((anchoVentana - ancho) / 2) + 'px',
					height: altoVentana + 'px',
					width: ancho + 'px',
					overflow: 'hidden'
				}

				this.estiloImg = JSON.parse(JSON.stringify(this.estilo))
				this.estiloImg.transform = 'rotate(' + rotacion + 'deg)'
				delete this.estiloImg.transform
			}
		},
		setPersona (ev) {
			API.setPersona(this.itemId, ev.data.PersonaID, ev.data.Nombre)
				.then(res => {
					this.item = res.data.item
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		delPersona (persona) {
			API.delPersona(this.itemId, persona.PersonaID)
				.then(res => {
					this.item = res.data.item
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		setEtiqueta () {
			const etis = this.etiqueta.split(' ').map(e => e.toString().toUpperCase()).filter(e => (e.length > 3))
			API.addItemTag(this.item.ItemID, etis)
				.then(res => {
					this.item = res.data.item
					this.etiqueta = ''
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		delEtiqueta (tag) {
			if (!this.galeria.Escritura) {
				return
			}
			API.delItemTag(this.item.ItemID, tag)
				.then(res => {
					this.item = res.data.item
					this.etiqueta = ''
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		setPortada () {
			API.setPortada(this.galeria.GaleriaID, this.item.ItemID)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Portada actualizada'
					})
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar fichero',
				mensaje: `¿Quieres eliminar este fichero?
				Esta acción no se podrá deshacer`,
				callback: acepta => {
					if (acepta) {
						API.delItem(this.itemId)
							.then(res => {
								const itemEliminado = this.itemId + 0
								if (this.listado.length > 1) {
									this.siguiente()
									this.listado = this.listado.filter(i => (i !== itemEliminado))
								} else {
									this.cerrar()
								}
								this.$store.commit('toast/success', {
									titulo: 'Fichero eliminado'
								})
								this.$store.commit('galerias/DEL_ITEM', itemEliminado)
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		toggleFavorito () {

		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>

<style scoped>
.item {
	position: fixed;
	display: block;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.4);
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}
.btnCerrar {
	position: fixed;
	display: block;
	top: 5px;
	right: 15px;
	font-size:2em;
	font-weight: bolder;
	color: black;
	text-shadow: 0 0 10px rgba(0,0,0,0.3);
	cursor: pointer;
	z-index: 10;
}

.capaContenido {
	position: fixed;
	display: block;
	top: 0;
	bottom: 0;
	left: 0;
	width: calc(100% - 300px);
	background-color: black;
}

.capaInformacion {
	position: fixed;
	display: block;
	top: 0;
	bottom: 0;
	right: 0;
	width: 300px;
	background-color: white;
	overflow-y: auto;
}
.capaFlechas {
	position: absolute;
	display: block;
	left: 0;
	width: 100%;
	top: 0;
	height: 100%;
	opacity: 0.1;
	z-index: 100;
	color: white;
	font-size: 6em;
}
.capaFlechas:hover {
	opacity: 0.5;
}
.flechaIzquierda {
	position: absolute;
	display: block;
	left: 10px;
	width:50px;
	top: 50%;
	margin-top: -15px;
	cursor: pointer;
	font-size: 6em;
	z-index: 100;
	opacity: 0.5;
}

.flechaIzquierda:hover {
	opacity: 1;
}

.flechaDerecha {
	position: absolute;
	display: block;
	right: 10px;
	top: 50%;
	width:50px;
	margin-top: -15px;
	cursor: pointer;
	font-size: 6em;
	z-index: 100;
	opacity: 0.5;
}

.flechaDerecha:hover {
	opacity: 1;
}
</style>




// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/visor-item/visor-item.vue